const isDev = process.env.NODE_ENV !== "production";

export const API_URL = isDev
    ? "/react-api"
    : "/grupabemo/react-api";